import { Component, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsCollection } from '@fcom/core-api';

@Component({
  selector: 'cms-conditional-accordion',
  templateUrl: './cms-conditional-accordion.component.html',
  styleUrls: ['cms-conditional-accordion.component.scss'],
  standalone: false,
})
export class CmsConditionalAccordionComponent {
  readonly DEFAULT_HEADER_LEVEL = 3;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  content = input.required<CmsCollection>();
}
